import _isEqual from 'lodash/isEqual';

import {
  getCategoriesPayloadFromLessonForm,
  getLessonCategoryIdsFromApiLesson,
} from 'helpers/getLessonCategoryIdsFromApiLesson';

export const convertDataToForm = (data: any, readOnly: any) => ({
  id: data.id,
  moduleId: data.moduleId,
  courseId: data.courseId,
  type: data.type,
  title: data.title || '',
  status: data.status,
  free: data.free,
  text: data.text,
  imageUrl: data.imageUrl,
  color: data.color || '',
  categories: getLessonCategoryIdsFromApiLesson(data),
  readOnly,
  statusError: false,
});

export const convertDataToApi = (data: any) => ({
  title: data.title,
  free: data.free,
  imageUrl: data.imageUrl,
  color: data.color,
  text: data.text,
  categories: getCategoriesPayloadFromLessonForm(data),
});

export const getChangedProperties = ({
  currentLesson,
  nextLesson,
}: {
  currentLesson: any;
  nextLesson: any;
}) => {
  const properties = [];

  if (currentLesson.title !== nextLesson.title) {
    properties.push('title');
  }

  if (currentLesson.free !== nextLesson.free) {
    properties.push('free');
  }

  if (currentLesson.text !== nextLesson.text) {
    properties.push('text');
  }

  if (currentLesson.imageUrl !== nextLesson.imageUrl) {
    properties.push('imageUrl');
  }

  if (currentLesson.color !== nextLesson.color) {
    properties.push('color');
  }

  if (
    !_isEqual(
      [...getLessonCategoryIdsFromApiLesson(currentLesson)].sort(),
      [...getCategoriesPayloadFromLessonForm(nextLesson)].sort(),
    )
  ) {
    properties.push('categories');
  }

  return properties;
};
